<template>
  <div class="content">
    <h1 class="has-text-centered">Arduino Mega Pins</h1>
    <div class="box">
      <p class="is-size-7-mobile">
          Der Arduino Mega 2560 ist ein Mikrocontroller-Board auf Basis des ATmega2560. Es verfügt über 54 digitale Eingangs-/Ausgangs-Pins (von denen 15 als PWM-Ausgänge verwendet werden können), 16 analoge Eingänge, 4 UARTs (serielle Hardware-Ports), einen 16-MHz-Quarzoszillator, einen USB-Anschluss, eine Stromversorgungsbuchse, einen ICSP-Header und eine Reset-Taste.
      </p>
    </div>
    <div class="box has-text-centered">
      <img src="@/assets/images/pinouts/Pinout-Mega2560.png">
      <p class="is-size-7-mobile">
        Bild von <a target="_blank" href="https://www.arduino.cc/">https://www.arduino.cc/</a>
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'pins-arduino-mega',
  metaInfo: {
    title: 'Arduino Mega Pins',
    meta: [
      {
        name: 'description',
        content: 'Der Arduino Mega 2560 ist ein Mikrocontroller-Board auf Basis des ATmega2560 der über 54 digitale Eingangs-/Ausgangs-Pins verfügt.'
      }
    ]
  },
  created () {
    this.$store.commit('updateNavTitle', { title: '<span class="fas fa-angle-left"></span> Zurück', route: 'pins' })
  }
}
</script>
